import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45293728"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sdds-col-md-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-row-additional" }, null, -1))

import { reactive, ref } from 'vue';
import options from '../helpers/options-file-template';
import { TypeImport } from '../types/constants';
import { SelectionEvent } from '../types/event';
import SddsDropdown from './common/BaseSddsDropdown.vue';
import SddsDropdownFilter from './common/BaseSddsDropdownFilter.vue';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileImporterAddData',
  props: {
  fileType: {
    type: String,
    default: null,
    required: true,
  }
},
  emits: ['template:validation', 'marketSelected'],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line


const marketSelection = ref(null);
const fieldsTemplate = ref([]);
const templateData = reactive({ market: null, template: {} });
const componentKey = ref(0);

const checkTemplate = () => {
  let valid = true;
  fieldsTemplate.value.forEach((item) => {
    const element = templateData.template[item.field];
    if (item.required && element.fieldReference == null) {
      valid = false;
    }
  });
  const templateMapper = { configuratorInstance: marketSelection.value };
  if (valid) {
    Object.entries(templateData.template).forEach(([key, item]: any) => {
      if (item.fieldReference !== null) {
        if (item.type === 'number') {
          templateMapper[key] = Number(item.fieldReference);
        } else {
          templateMapper[key] = item.fieldReference?.toString() ?? null;
        }
      }
    });
    if (props.fileType === TypeImport.YNT || props.fileType === TypeImport.YNT_MR)
      templateMapper['marketId'] = options.getMarketId(marketSelection.value);
  }
  emit('template:validation', { valid, template: templateMapper });
};

const handleUpdateSelectionField = (selection: SelectionEvent) => {
  console.log('handleUpdateSelection: ', selection);
  if (selection.keyDropdown) {
    templateData.template[selection.keyDropdown].fieldReference = selection.value;
  }
  checkTemplate();
};

const handleUpdateSelectionMarket = (selection: SelectionEvent) => {
  console.log('handleUpdateSelectionMarket: ', selection);
  fieldsTemplate.value.length = 0;
  marketSelection.value = selection.value;

  console.log(props.fileType);
  const additional = options.getAdditionalOptions(props.fileType, marketSelection.value);

  const temp = {};
  additional.forEach((item) => {
    temp[item.field] = { type: item.type, fieldReference: null };
    temp[item.field].fieldReference = item.options.length === 1 ? item.options[0].key : null;
  });

  templateData.market = selection.value;
  templateData.template = temp;
  fieldsTemplate.value.push(...additional);
  componentKey.value += 1;
  checkTemplate();
  emit('marketSelected', { selectedMarket: selection.value });
};
const getFieldTemplateData = (fieldId) => templateData.template[fieldId].fieldReference;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.fileType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(SddsDropdownFilter, {
            selection: marketSelection.value,
            "id-drop": "market",
            size: "small",
            "label-description": "Market",
            options: _unref(options).getOptionsMarkets(props.fileType),
            required: true,
            "onUpdate:selection": handleUpdateSelectionMarket,
            "data-test": "sddsDropDownMarket"
          }, null, 8, ["selection", "options"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldsTemplate.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "sdds-col-md-4",
        key: marketSelection.value - index
      }, [
        (_openBlock(), _createBlock(SddsDropdown, {
          key: marketSelection.value - index,
          selection: getFieldTemplateData(item.field),
          "id-drop": item.field,
          size: "small",
          "label-description": item.label,
          options: item.options,
          required: item.required,
          "onUpdate:selection": handleUpdateSelectionField,
          "data-test": "sddsDropDown"
        }, null, 8, ["selection", "id-drop", "label-description", "options", "required"]))
      ]))
    }), 128)),
    _hoisted_2
  ], 64))
}
}

})